import { isAnchorTagNode } from '../utils/isAnchorTagNode';
import { useSelectedNode } from './useSelectedNode';

export const useSelectedHyperlink = () => {
  const selection = useSelectedNode();
  return selection && isAnchorTagNode(selection) ? selection : null;
};
